import React, {Component} from "react";
import ReactDOM from 'react-dom';

import pixel from "../About/img/pole-pixel-villeurbanne-integral-service.jpg";
import styles from "./Contact.module.scss";

class Contact extends Component {

    render() {
        if (this.state && this.state.type && this.state.message) {
            var classString = 'alert alert-' + this.state.type;
            var status = <div id="status" className={classString} ref="status">
                           {this.state.message}
                         </div>;
        }

        return (
        <section className={styles.fh5coContact} id="fh5co-contact">
                <div className="container">
                    <div className="row">
                        <div className="col-md-5">
                            <h2 className="text-left">Nous contacter</h2>
                            <p>Vous avez un projet ? Ou vous souhaitez nous poser des questions ? N'hésitez pas, nous vous répondrons dans les plus brefs délais.</p>
                        </div>
                        <div className="col-md-7">

                            {status}

                            <form action="" method="POST" className="animate-box" onSubmit={this.handleSubmit.bind(this)}>
                                <input type="text" className="form-control" placeholder="Votre nom" id="name" name="name" ref="name" />
                                <input type="email" className="form-control" placeholder="Votre email" id="email" name="email" ref="email" />
                                <textarea className="form-control" placeholder="Votre message" id="message" name="message" ref="message" rows="6" />
                                <input type="submit" value="Envoyer" className="btn btn-primary" />
                            </form>
                        </div>
                    </div>
                </div>
        </section>
        );
    }

    handleSubmit(e){
      e.preventDefault();
      this.setState({ type: 'info', message: 'Envoi en cours...' }, this.sendFormData);
    }

    getFormData() {
        return {
            name:        this.refs.name.value,
            email:       this.refs.email.value,
            description: this.refs.message.value
        };
    }

    validateForm(formData) {
        if (
                formData.name        === "" || typeof formData.name        === "undefined"
            ||  formData.email       === "" || typeof formData.email       === "undefined"
            ||  formData.description === "" || typeof formData.description === "undefined"
        ) {
            return false;
        }

        return true;
    }

    sendFormData() {
        if (typeof window !== "undefined") {
            var _this = this;

            // Fetch form values.
            var formData = this.getFormData();

            if (!this.validateForm(formData)) {
                _this.setState({ type: 'danger', message: 'Veuillez renseigner tous les champs du formulaire' });
                return false;
            }

            // Send the form data.
            var xmlhttp = new XMLHttpRequest();
            
            xmlhttp.onreadystatechange = function() {
              if (xmlhttp.readyState === 4) {

                var response = null;

                try {
                  var response = JSON.parse(xmlhttp.responseText);
                } catch (e) {}

                if (xmlhttp.status === 200 && response !== null && response.status === 'OK') {
                  _this.setState({ type: 'success', message: 'Merci ! Nous vous répondrons au plus vite !' });
                  _this.refs.name.value    = "";
                  _this.refs.email.value   = "";
                  _this.refs.message.value = "";
                }
                else {
                  _this.setState({ type: 'danger', message: 'Désolé, une erreur est survenue. Merci de nous contacter par email : info@integral-service.fr' });
                }
              }
            };
            xmlhttp.open('POST', '/php/send.php', true);
            xmlhttp.setRequestHeader('Content-type', 'application/x-www-form-urlencoded');
            xmlhttp.send(this.requestBuildQueryString(formData));
        }
    }

    requestBuildQueryString(params){    
        var queryString = [];
        for(var property in params)
            if (params.hasOwnProperty(property)) {
            queryString.push(encodeURIComponent(property) + '=' + encodeURIComponent(params[property]));
            }
    
        return queryString.join('&');
    
    }
}

export default Contact;



// WEBPACK FOOTER //
// ./src/components/Contact/Contact.jsx